import { events } from "#site/content";

const MONTH_NAMES = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

export function getAllEvents() {
  return [...events].sort((a, b) => {
    if (a.startDate && b.startDate) return a.startDate.localeCompare(b.startDate);
    if (a.startDate) return -1;
    if (b.startDate) return 1;
    return a.month - b.month;
  });
}

export function getEventBySlug(slug: string) {
  return events.find((e) => e.slug === slug);
}

export function getEventsByMonth(month: number) {
  return getAllEvents().filter((e) => e.month === month);
}

export function getUniqueCountries(): string[] {
  const countries = new Set<string>();
  for (const e of events) {
    countries.add(e.location.country);
  }
  return Array.from(countries).sort();
}

export function getUniqueBoatClasses(): string[] {
  const classes = new Set<string>();
  for (const e of events) {
    for (const bc of e.boatClasses) {
      classes.add(bc);
    }
  }
  return Array.from(classes).sort();
}

export function getUniqueEventTypes(): string[] {
  const types = new Set<string>();
  for (const e of events) {
    types.add(e.eventType);
  }
  return Array.from(types).sort();
}

export function getEventCount(): number {
  return events.length;
}

export function getUpcomingEvents(limit = 5) {
  const today = new Date().toISOString().split("T")[0];
  return getAllEvents()
    .filter((e) => e.startDate && e.startDate >= today)
    .slice(0, limit);
}

export function formatEventDate(event: { startDate?: string; endDate?: string; recurrence?: string; month: number }): string {
  if (event.startDate) {
    const start = new Date(event.startDate);
    const startStr = start.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric", timeZone: "UTC" });
    if (event.endDate) {
      const end = new Date(event.endDate);
      if (start.getUTCMonth() === end.getUTCMonth()) {
        return `${start.toLocaleDateString("en-US", { month: "short", day: "numeric", timeZone: "UTC" })}–${end.getUTCDate()}, ${end.getUTCFullYear()}`;
      }
      return `${startStr} – ${end.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric", timeZone: "UTC" })}`;
    }
    return startStr;
  }
  if (event.recurrence) return event.recurrence;
  return MONTH_NAMES[event.month - 1];
}

export function formatLocation(location: { city: string; state?: string; country: string }): string {
  const parts = [location.city];
  if (location.state) parts.push(location.state);
  parts.push(location.country);
  return parts.join(", ");
}

export function formatEventType(type: string): string {
  return type
    .split("-")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}

export function getMonthName(month: number): string {
  return MONTH_NAMES[month - 1];
}
